import type { PlainWorkflowExecution } from "@/queries/automation-queries";
import type { FC } from "react";
import { SubjectDisplay } from "@/components/SubjectDisplay";
import { triggerName } from "@/utils/automations";

type ExecutionTriggerInfoProps = {
    execution: PlainWorkflowExecution;
};

export const ExecutionTriggerInfo: FC<ExecutionTriggerInfoProps> = ({ execution }) => {
    const triggerType = triggerName(execution.spec?.trigger);
    const creator = execution.metadata?.creator;
    const executor = execution.metadata?.executor;

    const isSameIdentity = creator?.id && executor?.id && creator.id === executor.id;

    if (isSameIdentity && creator) {
        return (
            <div className="flex flex-wrap items-center gap-1.5 text-sm text-content-muted">
                <span className="text-content-primary">{triggerType}</span>
                <span className="text-content-inactive">•</span>
                <span>Triggered by / ran as:</span>
                <SubjectDisplay subject={creator} avatarSize={16} />
            </div>
        );
    }

    return (
        <div className="flex flex-wrap items-center gap-1.5 text-sm text-content-muted">
            <span className="text-content-primary">{triggerType}</span>
            {creator && (
                <>
                    <span className="text-content-inactive">•</span>
                    <span>Triggered by:</span>
                    <SubjectDisplay subject={creator} avatarSize={16} />
                </>
            )}
            {executor && (
                <>
                    <span className="text-content-inactive">•</span>
                    <span>Ran as:</span>
                    <SubjectDisplay subject={executor} avatarSize={16} />
                </>
            )}
        </div>
    );
};
